import styled from 'styled-components';
import { Paper } from 'components/_shared/Paper';

export const Wrapper = styled(Paper)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
